import React, { useMemo } from 'react';
import moment from 'moment';
import {
  StyledUserActivityItem,
  UserActivityAvatar,
  UserActivityItemContent,
  UserActivityItemMessage,
  UserActivityItemTime,
  UserActivityComments,
} from './UserActivityItemStyles';
import { DATE_FORMAT } from '../../../CommonComponents/MaskedInput';
import { Activity, ActivityType } from '../../UserActivityTypes';

interface Props {
  activity: Activity;
  color: string;
}

export const UserActivityItem: React.FC<Props> = ({ activity, color }) => {
  const formattedTime = moment(activity.Time).format('h:mm A');

  const activityMessage = useMemo(() => {
    if (!activity.IsActivity) {
      return activity.Message;
    }

    const date = moment(activity.Time).format(DATE_FORMAT);

    if (activity.ActivityType === ActivityType.DeliveryOfPlan) {
      return `${activity.UserName} delivered the plan on ${date}${
        activity.Comment ? ' with the following comments:' : ''
      }`;
    }

    return `${activity.UserName} recorded the activity: "${activity.ActivityName}" on ${date}${
      activity.Comment ? ' with the following comments:' : ''
    }`;
  }, [activity]);

  return (
    <StyledUserActivityItem>
      <UserActivityAvatar style={{ backgroundColor: color }}>{activity.Initial}</UserActivityAvatar>
      <UserActivityItemContent>
        <UserActivityItemMessage>{activityMessage}</UserActivityItemMessage>
        {activity.Comment && <UserActivityComments>{activity.Comment}</UserActivityComments>}
      </UserActivityItemContent>
      <UserActivityItemTime>{formattedTime}</UserActivityItemTime>
    </StyledUserActivityItem>
  );
};
